<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("system") }} {{ $t("logs") }}</div>
      </div>
      <div class="mx-2">
        <!-- <b-dropdown name="listview" id="listview" variant="outline-blue">
          <template v-slot:button-content>
            Viewing&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp;
            <strong>{{ rows }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown> -->
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <div>
          <b-form-input
            @input="onSearch"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
        <div class="d-flex align-items-center">
          <div v-if="logs.length > 0">
            Download as:<img
              class="mx-1"
              @click="excelDownload()"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </div>
          <div class="mx-2">
            <b-dropdown variant="outline-blue">
              <template v-slot:button-content>
                <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
            <b-button variant="default" @click="onFetch()" class="btn-blue">{{
              $t("fetch")
            }}</b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table">
      <thead>
        <tr>
          <th class="" style="width: 150px">
            <img
              v-if="this.columnName != 'first_name'"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('first_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("user") }}
          </th>
          <th class="" style="width: 150px">
            <img
              v-if="this.columnName != 'system_log_master_name'"
              @click="onSortValue('system_log_master_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('system_log_master_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('system_log_master_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("type") }}
          </th>
          <th class="" style="width: 150px">
            <img
              v-if="this.columnName != 'system_log_timestamp'"
              @click="onSortValue('system_log_timestamp', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('system_log_timestamp', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('system_log_timestamp', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />{{ $t("date") }}
          </th>
          <th class="" style="width: 100px">
            {{ $t("time") }}
          </th>
          <th class="" style="width: 150px">
            <img
              v-if="this.columnName != 'module_name'"
              @click="onSortValue('module_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('module_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('module_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("module") }}
          </th>
          <th class="">{{ $t("activity") }}</th>
        </tr>
      </thead>
      <tbody v-if="logs.length > 0">
        <tr v-for="(log, logIndex) in logs" :key="logIndex">
          <td>{{ log.first_name + " " + log.last_name }}</td>
          <td>{{ log.system_log_master_name }}</td>
          <td>{{ log.system_log_timestamp | dateparse }}</td>
          <td>{{ log.sl_time ? moment(log.sl_time).format("HH:mm") : "-" }}</td>
          <td>{{ log.module_name }}</td>
          <!-- //text-truncate -->
          <td
            class=""
            v-b-tooltip.hover
            :title="log.system_log_message"
            style="cursor: pointer"
          >
            {{ log.system_log_message }}
          </td>
        </tr>
      </tbody>
      <tbody v-if="logs.length == 0">
        <tr>
          <td colspan="6">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import ExhibitorService from "@/services/ExhibitorService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from "xlsx";
import xlsx from "json-as-xlsx";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      perPageExcel: 100000,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      //for search
      debounce: null,
      searchValue: "",
      searchKey: "", //the key name in your table

      gridView: false,
      listView: true,
      selectedNew: "",
      viewingnumbers: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      logs: [],
      logsExcel: [],
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    this.getviewingnumber();
    // this.getSystemLogs();
    // this.getSystemLogsExcel();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    onFetch: function () {
      this.getSystemLogs();
      this.getSystemLogsExcel();
    },
    excelDownload() {
      let temp_data = this.logsExcel;
      // let temp_arr = [];
      // temp_data.map(x => {
      //   x.selectedUsers.map(y => {
      //     let obj = {
      //       ...x,
      //       ...y
      //     };
      //     temp_arr.push(obj);
      //   });
      // });
      // console.log({temp_arr})
      let dateparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
        //this is changed acc to mams decision
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };

      let data = [
        {
          sheet: "System Logs",
          columns: [
            {
              value: (row) => row.first_name + " " + row.last_name,
              label: "User",
            },
            {
              value: "system_log_master_name",
              label: "Type",
            },
            {
              value: (row) => dateparse(row.system_log_timestamp),
              label: "Date",
            },
            {
              value: (row) =>
                row.sl_time ? moment(row.sl_time).format("HH:mm") : "-",
              label: "Time",
            },
            {
              value: "module_name",
              label: "Module	",
            },
            {
              value: "system_log_message",
              label: "Activity",
            },

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `SystemLog${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    //  ExportExcel(type, fn, dl) {
    //   var elt = this.$refs.exportable_table;
    //   var wb = XLSX.utils.table_to_book(elt, {sheet:"Sheet JS"});

    //   return dl ?
    //   XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
    //   XLSX.writeFile(wb, fn || (('DistributorCollectionReport.') + (type || 'xlsx')));
    // },
    getSystemLogsExcel() {
      let payload = {
        limit: this.perPageExcel,
        currentPage: 1,
        searchValue: "",
        searchKey: "",
        columnName: "",
        orderBy: "",
      };
      ExhibitorService.GetSystemLogs(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            console.log("resp", response);
            this.logsExcel = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    moment,
    getSystemLogs() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        searchKey: this.searchKey,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      ExhibitorService.GetSystemLogs(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            console.log("resp", response);
            this.logs = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue = this.perPage;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSearch: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.movies = this.MoviesCopy.filter((x) => {
          if (
            x.movie_title
              .toLowerCase()
              .includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.movies = this.MoviesCopy;
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getSystemLogs();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getSystemLogs();
      } else {
        this.currentPage = event;
        this.getSystemLogs();
      }
    },

    //search
    onSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchValue = event;
        this.perPage = 10;
        this.currentPage = 1;
        this.getSystemLogs();
      }, 1500);
      // console.log('TO DO :>> ');
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SystemLogs/listSystemLogs.vue